export default {
  SET_PAYMENT_LIST (state, paymentList) {
    state.paymentList = paymentList
  },
  SET_LOADING (state, loading) {
    state.loading = loading
  }
}
